import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Icon, Text, VStack } from "native-base";
import React from "react";

import FormButton from "@/components/atoms/FormButton";
import Modal from "@/components/molecules/Modal";
import { Address } from "@/interfaces/domain/Address";

type AddressInfoModalProps = {
  modalVisible: boolean;
  address?: Address;
  isDeleting: boolean;
  onClose: () => void;
  onPressDelete: () => void;
};

const AddressInfoModal = ({
  modalVisible,
  isDeleting,
  address,
  onClose,
  onPressDelete,
}: AddressInfoModalProps) => {
  return (
    <Modal
      isOpen={modalVisible}
      onClose={onClose}
      Header="Endereço"
      Body={
        <VStack>
          <Text fontSize="lg" bold>{`${address?.rua}, ${address?.numero}`}</Text>
          <Text isTruncated>{address?.complemento}</Text>
          <Text isTruncated>{address?.referencia}</Text>
          <Text isTruncated>{`${address?.cidade}, ${address?.estado}`}</Text>
        </VStack>
      }
      Footer={
        <VStack w="full">
          <FormButton
            w="full"
            mb={22}
            isLoading={isDeleting}
            leftIcon={
              <Icon as={<MaterialCommunityIcons name="trash-can" />} size="md" color="white.50" />
            }
            onPress={onPressDelete}>
            Excluir
          </FormButton>
          <FormButton
            w="full"
            mb={22}
            colorScheme="white"
            textColor="primary.700"
            onPress={onClose}>
            Cancelar
          </FormButton>
        </VStack>
      }
    />
  );
};

export default AddressInfoModal;
